export default "__VITE_ASSET__c1500ef8__"